<template xmlns="http://www.w3.org/1999/html">
  <div style="width: 100vw;height: 100vh;background-color: white;">
    <img src="/static/images/ylm/banner.png" style="width: 100vw;">
    <div style="width: 100vw;display: flex;align-items: center;justify-content: center;">
      <div style="width: 85vw;display: flex;flex-direction: column;justify-content: center;margin-top: 10px;">
        <div style="width: 100%;margin-top: 15px;vertical-align: middle;">
          <span>一、</span>
          <img src="/static/images/ylm/logo.png" style="width: 24.5vw;display: inline-block;vertical-align: middle;">
          <span>防伪验证码图示如下：</span>
        </div>


        <span style="margin-top: 5vh;">1、绿色防伪验证码图片示意（刮开前/后）</span>
        <div style="width: 100%;display: flex;align-items: center;justify-content: center;margin-top: 3vh;">
          <img src="/static/images/ylm/lv1.png" style="width: 35vw;margin-right: 10px;"></img>
          <img src="/static/images/ylm/lv2.png" style="width: 35vw;margin-left: 10px;"></img>
        </div>
        <span style="margin-top: 5vh;">2、紫色防伪验证码图片示意（刮开前/后）</span>
        <div style="width: 100%;display: flex;align-items: center;justify-content: center;margin-top: 3vh;">
          <img src="/static/images/ylm/zi1.png" style="width: 35vw;margin-right: 10px;"></img>
          <img src="/static/images/ylm/z2.png" style="width: 35vw;margin-left: 10px;"></img>
        </div>

        <div style="width: 100%;margin-top: 5vh;vertical-align: middle;">
          <span>二、</span>
          <img src="/static/images/ylm/logo.png" style="width: 24.5vw;display: inline-block;vertical-align: middle;">
          <span>防伪验证码查询，请刮开涂层后，在下方输入16位防伪验证码，进行验证。</span>
        </div>


        <div v-if="showMessage" style="width: 100%;display: flex;justify-content: center;margin-top: 20px;">
          <div style="width: 70vw;color: red;text-align: center;">
            {{antiMessage}}
          </div>
        </div>


        <div style="width: 100%;display: flex;justify-content: center;">
          <input v-model="antiCode" @input="handleInput" maxlength="19"
            style="padding-left: 15px;width: 80vw;height:40px;margin-top: 30px;border: 1.7px solid black;border-radius: 5px;" />
        </div>


        <div style="width: 100%;display: flex;justify-content: center;">
          <div @click="getResult"
            style="width: 40vw;height:40px;margin-top: 20px;margin-bottom: 6vh;border-radius: 5px;background-color: black;color: white;display: flex;justify-content: center;align-items: center;">
            Check&nbsp;&nbsp;&nbsp;查询</div>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import { getAntiData } from '../../api/api'

export default {
  data() {
    return {
      eno: "138224402208",
      antiCode: "",
      showMessage: false,
      antiMessage: ""
    }
  },
  methods: {
    oldAnti() {
      window.location.href = "http://business.yesno.com.cn/Sup8/page/ROYAL/index.aspx";
    },
    handleInput() {
      this.antiCode = this.antiCode.replace(/(\w{4})(?=\w)/g, '$1-')
    },
    async getResult() {
      var antiData = this.antiCode.replace(/-/g, '')
      if(antiData.length!=16){
        alert("请输入正确的16位防伪码进行查询")
        return
      }
      var res = await getAntiData(antiData, this.eno);
      var data = res.data;
      if (data == null || data.code == "500") {
        this.antiMessage="查询异常，请重新输入码进行查询"
      }else{
        this.antiMessage=data.message
      }
      this.showMessage=true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/YouLeMei/Query.vue